import React from 'react';
import './card.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faChevronUp} from '@fortawesome/free-solid-svg-icons'

import AnimateHeight from 'react-animate-height';

export default class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: this.props.collapsable ? this.props.open : true,
        }

    }


    toggleOpen = () => {
        if (!this.props.collapsable) {
            return
        }
        this.setState(Object.assign(this.state, {open: !this.state.open}));
    };

    internalClickHandler = (e) => {
        e.preventDefault();
        this.props.onClickHandler(e);
    };

    render() {
        return (
            <div className={this.props.className}>
                <div className={"col-12 p-1 card-row"} >
                    <div className={"col-12 d-flex align-items-center title-div"} onClick={this.toggleOpen}>
                        <span style={{width: '95%',textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden'}}>{this.props.title}</span>
                        {this.props.collapsable ? <FontAwesomeIcon style={{transition: '.200s ease-in-out'}} className={"fa-style-adj"} icon={faChevronUp} rotation={this.state.open ? null : 180}/> : null }
                    </div>

                    <AnimateHeight  className={"col-12 body-style"} duration={250} height={this.state.open ? 'auto' : '0%'}>
                        <div className={"w-100 mt-1 border-div"}  />
                        {this.props.body}
                        {this.props.children}
                        { (this.props.buttonText === undefined || this.props.buttonText === null) ? null : <button className={"btn btn-block mb-3 button-style "} onClick={this.internalClickHandler}>{this.props.buttonText}</button>}

                    </AnimateHeight>

                </div>
            </div>

        )
    }
}

Card.defaultProps = {
    collapsable: true
};
